// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 企业认证（提交后待审核） POST /api/v1/auth/enterprise-auth */
export async function AuthControllerEnterpriseAuthV1(
  body: MyApi.EnterpriseVerificationDto,
  options?: { [key: string]: any }
) {
  return request<any>("/api/v1/auth/enterprise-auth", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 用户登出 POST /api/v1/auth/logout */
export async function AuthControllerLogoutV1(options?: { [key: string]: any }) {
  return request<any>("/api/v1/auth/logout", {
    method: "POST",
    ...(options || {}),
  });
}

/** 获取当前用户信息 GET /api/v1/auth/me */
export async function AuthControllerGetCurrentUserV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputUserDto>("/api/v1/auth/me", {
    method: "GET",
    ...(options || {}),
  });
}

/** 我的租户列表（可切换） 普通用户仅返回已加入的租户；平台超级管理员（super_admin）返回系统内全部租户并可切换任意租户。 GET /api/v1/auth/my-tenants */
export async function AuthControllerListMyTenantsV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputTenantMembershipDtoArray>(
    "/api/v1/auth/my-tenants",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 刷新访问令牌 POST /api/v1/auth/refresh */
export async function AuthControllerRefreshV1(
  body: MyApi.RefreshTokenDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseAuthTokenOutput>("/api/v1/auth/refresh", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 短信验证码重置密码 PATCH /api/v1/auth/reset-password */
export async function AuthControllerResetPasswordV1(
  body: MyApi.ResetPasswordDto,
  options?: { [key: string]: any }
) {
  return request<any>("/api/v1/auth/reset-password", {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 用户登录 POST /api/v1/auth/sign-in */
export async function AuthControllerSignInV1(
  body: MyApi.LoginDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputAuthDto>("/api/v1/auth/sign-in", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 用户注册 POST /api/v1/auth/sign-up */
export async function AuthControllerSignUpV1(
  body: MyApi.RegisterDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputAuthDto>("/api/v1/auth/sign-up", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 切换当前租户（更新默认租户并刷新 Token） 普通用户需具备目标租户的有效成员关系；平台超级管理员可切换至任意已存在租户。 POST /api/v1/auth/switch-tenant */
export async function AuthControllerSwitchTenantV1(
  body: MyApi.SwitchTenantDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputAuthDto>("/api/v1/auth/switch-tenant", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
